import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/lib/api-client'
import { CACHE_CONFIG } from '~/lib/cache-config'
import { localeToLanguageCode, type Locale } from '~/lib/i18n/shared'

export function rankingsHubQueryOptions(year: number, locale: string) {
  const lang = localeToLanguageCode(locale as Locale)

  return queryOptions({
    queryKey: ['rankings', 'yearly', year, lang],
    queryFn: async () => {
      const res = await apiClient.rankings.yearly[':year'].$get({
        param: { year: String(year) },
        query: { lang },
      })
      if (res.status === 404) {
        return {
          year,
          categories: [],
          awards: [],
        }
      }
      if (!res.ok) throw new Error(`Failed to fetch rankings for ${year}`)
      return res.json()
    },
    staleTime: CACHE_CONFIG.reference.staleTime,
    gcTime: CACHE_CONFIG.reference.gcTime,
  })
}

export function useRankingsHub(year: number, locale: string) {
  return useSuspenseQuery(rankingsHubQueryOptions(year, locale))
}
